import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const SahibindenSsoModal = () => {
  const { t } = useTranslation(['auth']);

  return (
    <>
      <Button
        color="gray.900"
        onClick={() => {
          window.location.href = `${import.meta.env.VITE_API_URL}/v1/auth/saml/initiate`;
        }}
        variant="outline"
      >
        {t('auth:login.ssoLogin')}
      </Button>
    </>
  );
};
